import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import ForgotPassword from "../auth/forms/ForgotPassword";


export default function ForgotPasswordWrapper(props) {

    return (
        <>
            <UiAuthContainer >
                <div className="sb-auth-top-wr sb-auth-forgot-pwd">
                    <h2>Forgot Password</h2>
                    <div className='sba-auth-top-heading'>
                        <h5>Please enter your registered email address</h5>
                    </div>
                    <ForgotPassword />
                    <UiAuthFooterContainer/>
                </div>
            </UiAuthContainer>

        </>
    );
}
